import { useEffect, useState } from 'react';
import { api, ApiError, type Providers } from '../api';

const ROLE_KEYS = ['tenant_admin', 'manager', 'lead', 'sales_rep'] as const;

export function Login() {
  const [providers, setProviders] = useState<Providers | null>(null);
  const [devEmail, setDevEmail] = useState('dgowda@cbcinc.ai');
  const [devRole, setDevRole] = useState<(typeof ROLE_KEYS)[number]>('tenant_admin');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<Providers>('/api/auth/providers')
      .then(setProviders)
      .catch(() => setError('Could not reach the API.'));
  }, []);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('error') === 'wrong-tenant') {
      setError('That account belongs to a different company. Sign in at your own crmhub subdomain.');
    }
  }, []);

  async function devLogin(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.post('/api/auth/dev-login', { email: devEmail, roleKey: devRole });
      window.location.reload();
    } catch (err) {
      setError(
        err instanceof ApiError && err.message
          ? err.message
          : 'Dev login failed. Check the email domain matches a seeded tenant.',
      );
    }
  }

  return (
    <div className="container">
      <div className="card stack">
        <div>
          <h1>Sign in to crmhub</h1>
          <p className="muted">Your tenant is determined by your email domain.</p>
        </div>

        {error && <p style={{ color: '#b91c1c' }}>{error}</p>}

        <div className="row">
          <a
            className="btn"
            href="/api/auth/microsoft"
            aria-disabled={!providers?.microsoft}
            style={!providers?.microsoft ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
          >
            Continue with Microsoft
          </a>
          <a
            className="btn"
            href="/api/auth/google"
            aria-disabled={!providers?.google}
            style={!providers?.google ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
          >
            Continue with Google
          </a>
        </div>
        {providers && !providers.microsoft && !providers.google && (
          <p className="muted">SSO providers are not configured yet (awaiting credentials).</p>
        )}

        {providers?.devLogin && (
          <form className="stack" onSubmit={devLogin} style={{ borderTop: '1px solid #e5e7eb', paddingTop: '1rem' }}>
            <p className="muted">Developer login (non-production only)</p>
            <input
              type="email"
              value={devEmail}
              onChange={(e) => setDevEmail(e.target.value)}
              placeholder="you@cbcinc.ai"
            />
            <select value={devRole} onChange={(e) => setDevRole(e.target.value as typeof devRole)}>
              {ROLE_KEYS.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
            <button className="btn btn-primary" type="submit">
              Dev sign in
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
